module.exports = __webpack_public_path__ + "img/img-1.ced81637.jpg";